module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('span', [_c('i', [_vm._v("It is so difficult to wait in graves")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('span', [_c('i', [_vm._v("To watch the flowers at the lip")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('span', [_c('i', [_vm._v("To sleep wide-eyed beneath the sky;")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('span', [_c('i', [_vm._v("For centuries, to watch the stone")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ded3"
  }, [_c('span', [_c('i', [_vm._v("It is so difficult to wait")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "ded4"
  }, [_c('span', [_c('i', [_vm._v("In your grave")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded5"
  }, [_c('span', [_vm._v("—"), _c('i', [_vm._v("Alone")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', [_vm._v("Denton Welch 1940–41")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cb6c9d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0